import script from "./SpecTable.vue?vue&type=script&setup=true&lang=js"
export * from "./SpecTable.vue?vue&type=script&setup=true&lang=js"

import "./SpecTable.vue?vue&type=style&index=0&id=2bec4dff&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2bec4dff"]])

export default __exports__